import { Task, Tool } from 'shared/types';
import { i18n } from '../../i18n/i18n';

/** Shared bits of the Admin tabs (split out of AdminPanel.tsx, 2026-10-12). */

export function parseTemplateChecklistForPreview(raw: unknown): Array<{ text: string; image_url?: string | null }> {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw as Array<{ text: string; image_url?: string | null }>;
  if (typeof raw === 'string') {
    try {
      const p = JSON.parse(raw);
      return Array.isArray(p) ? p : [];
    } catch {
      return [];
    }
  }
  return [];
}

/** Build a Task-shaped object for read-only preview (system standard or family-saved template rows) */
export function taskLibraryTemplateToPreviewTask(tpl: any, family: { tools?: Tool[] } | null): Task {
  const arr = parseTemplateChecklistForPreview(tpl.checklist_items);
  const checklist = arr.map((item, i) => ({
    id: `tpl-preview-${tpl.id}-${i}`,
    text: String(item.text || ''),
    images:
      item.image_url != null && String(item.image_url).trim() !== ''
        ? [String(item.image_url).trim()]
        : [],
  }));
  const toolKeys: string[] = Array.isArray(tpl.tool_keys) ? tpl.tool_keys : [];
  const toolIds = (family?.tools || [])
    .filter((t: any) => t.tool_key && toolKeys.includes(t.tool_key))
    .map((t: any) => t.id);
  return {
    id: String(tpl.id),
    title: String(tpl.title || ''),
    description: tpl.description ? String(tpl.description) : undefined,
    room_id: tpl.room_id != null && String(tpl.room_id).trim() !== '' ? String(tpl.room_id) : null,
    points: Number(tpl.points) || 0,
    checklist,
    tools: toolIds,
    is_completed: false,
    created_at: new Date(),
    header_image_url: tpl.header_image_url ? String(tpl.header_image_url) : undefined,
    age_group: tpl.age_group,
  } as Task;
}

// Interface for member creation data
export interface MemberCreationData {
  name: string;
  username: string;
  pin: string;
  email?: string;
  isAdmin: boolean;
  member_type: 'adult' | 'child';
}

/** Translated age-group label ("8–9 years", "Grown-ups", …); unknown codes fall back to the code. */
export const ageLabel = (code?: string | null): string => {
  const key = !code || code === 'all' || code === 'all_ages' ? 'age_all' : code;
  const t = i18n.t(`library.${key}` as any);
  return t === `library.${key}` ? (code || '') : t;
};
